import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  input,
  OnDestroy,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-app-columns-popup',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatButtonModule, MatIconModule],
  templateUrl: './ag-grid-columns-filter-panel.component.html',
  styleUrls: ['./ag-grid-columns-filter-panel.component.scss'],
})
export class AgGridColumnsFilterPanelComponent
  implements AfterViewInit, OnDestroy
{
  public popupRef = viewChild.required<ElementRef<HTMLElement>>('popup');
  public popupContentRef =
    viewChild.required<ElementRef<HTMLElement>>('popupcontent');

  public anchor = input.required<HTMLElement>();
  public isDirty = input<boolean>(false);

  public resetColumns = output<void>();
  public closePopeup = output<void>();
  public save = output<void>();
  showPopup = signal(false);

  onSave() {
    this.save.emit();
    this.closePopup();
  }

  openPopup() {
    if (this.showPopup()) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.positionBelowRight(10);
        this.showPopup.set(true);
      });
    });
  }

  closePopup() {
    this.showPopup.set(false);
    this.closePopeup.emit();
  }

  addStyles(parentEl: HTMLElement): void {
    const contentElement = parentEl.querySelector<HTMLElement>('.content');
    if (contentElement) {
      const contentClassnames = Array.from(contentElement.classList).filter(
        (e) => e !== 'content'
      );
      parentEl.classList.add(...contentClassnames);
    }
  }

  onReset() {
    if (!this.canReset()) return;
    this.resetColumns.emit();
  }

  ngAfterViewInit() {
    window.visualViewport?.addEventListener(
      'resize',
      this.viewportResizeHandler
    );
  }

  positionBelowRight(verticalOffset = 0) {
    const popupEl = this.popupRef()?.nativeElement;
    const popupWidth = popupEl.offsetWidth || 292;
    const rect = this.anchor().getBoundingClientRect();
    const visualViewport = window.visualViewport;

    let top = rect.bottom + verticalOffset;
    let left = rect.right - popupWidth;

    if (visualViewport) {
      top += visualViewport.offsetTop;
      left += visualViewport.offsetLeft;
    }
    popupEl.style.top = `${Math.round(top)}px`;
    popupEl.style.left = `${Math.round(left)}px`;
  }

  readonly viewportResizeHandler = () => {
    if (this.popupRef()?.nativeElement.classList.contains('active')) {
      this.positionBelowRight(10);
    }
  };

  public canReset = input<boolean>(false);

  ngOnDestroy() {
    this.closePopeup.emit();
    window.visualViewport?.removeEventListener(
      'resize',
      this.viewportResizeHandler
    );
    this.popupRef()?.nativeElement.remove();
  }
}
